<template>
  <div class="container">
    <Header></Header>
    <headerSearch></headerSearch>
    <mainTab></mainTab>
    <div class="brand_show_detail w1440">
      <div class="fs14 flex-box wrap1">
        <span class="col90">当前位置：</span>
        <router-link class="col04" to="/BrandShow"
          >优选品牌<span class="plr5"> / </span>品牌详情<span class="plr5"> / </span></router-link
        >
        <span class="col04">{{ brand.name }}</span>
      </div>

      <section class="top_info_box flex-box">
        <div class="flex-grow-1">
          <h1>{{ brand.name }}</h1>
          <div class="info flex-box">
            <p class="key">品牌拼音</p>
            ：
            <span class="flex-grow-1">{{ brand.pinyin }}</span>
          </div>
          <div class="info flex-box">
            <p class="key flex-box flex-between"><span>产</span><span>地</span></p>
            ：
            <span class="flex-grow-1">{{ brand.place }}</span>
          </div>
          <div class="info flex-box">
            <p class="key">生产厂家</p>
            ：
            <span class="flex-grow-1">{{ brand.company }}</span>
          </div>
        </div>
        <div class="img_box">
          <img :src="brand.image_text" />
        </div>
      </section>

      <section class="brand_tab_row flex-box">
        <div class="tab flex-box flex-center" @click="testTabClick(0)" :class="tabIndex == 0 ? 'active' : ''">
          <i class="icon1"></i>
          <span>品牌介绍</span>
        </div>
        <div class="tab flex-box flex-center" @click="testTabClick(1)" :class="tabIndex == 1 ? 'active' : ''">
          <i class="icon2"></i>
          <span>产品图册</span>
        </div>
        <div class="tab flex-box flex-center" @click="testTabClick(2)" :class="tabIndex == 2 ? 'active' : ''">
          <i class="icon3"></i>
          <span>品牌荣誉</span>
        </div>
        <div class="tab flex-box flex-center" @click="testTabClick(3)" :class="tabIndex == 3 ? 'active' : ''">
          <i class="icon4"></i>
          <span>厂商介绍</span>
        </div>
      </section>

      <section class="detail_box">
        <section class="block1" v-if="tabIndex == 0">
          <div class="flex-box flex-center">
            <div v-html="brand.content"></div>
          </div>
          <div class="video_box" v-if="brand.video_file">
            <video :src="brand.video_file_text" class="video" controls></video>
            <!-- <img src="@/assets/static/icon/z_icon_play1.png" class="icon_play" /> -->
          </div>

          <div v-if="!brand.content && brand.video_file" class="nodata fs16 tc">
            <img src="@/assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
            <div>暂无相关数据</div>
          </div>
        </section>

        <section class="block2" v-if="tabIndex == 1">
          <ul class="flex-box flex-wrap">
            <li v-viewer v-for="(item, index) in brand.album_images_text" :key="index">
              <img :src="item" class="img" />
              <div class="preview">
                <i @click="showImagesInViewer(brand.album_images_text,index)"></i>
              </div>
            </li>
          </ul>
          <div v-if="brand.album_images_text.length == 0" class="nodata fs16 tc">
            <img src="@/assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
            <div>暂无相关数据</div>
          </div>
        </section>

        <section class="block3" v-if="tabIndex == 2">
          <div class="flex-box flex-center">
            <div v-html="brand.honor_content"></div>
          </div>
          <div v-if="!brand.honor_content" class="nodata fs16 tc">
            <img src="@/assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
            <div>暂无相关数据</div>
          </div>
        </section>

        <section class="block3" v-if="tabIndex == 3">
          <div class="flex-box flex-center">
            <div v-html="brand.intro"></div>
          </div>
          <div v-if="!brand.intro" class="nodata fs16 tc">
            <img src="@/assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
            <div>暂无相关数据</div>
          </div>
        </section>
      </section>

      <section class="product_box1" v-if="goodsList.length > 0">
        <div class="flex-box">
          <p class="flex-grow-1 title">旗下产品</p>
          <router-link to="/FindProduct" target="_blank" class="nav_more">更多 </router-link>
        </div>
        <div class="product_list1 flex-box flex-wrap">
          <div class="product_item cursor" v-for="(item, index) in goodsList" :key="index" @click="onDetail(item.id)">
            <div class="img_wrap">
              <img :src="item.image_text" class="img1" />
            </div>
            <div class="info_wrap">
              <div class="m-ellipsis mb5 name fs16">{{ item.title }}</div>
              <div class="mb5 zprice1 fs16 fwb" v-if="!userInfo">价格登录可见</div>
              <div class="mb5 flex-box flex-col-baseline zprice1" v-else>
                <div class="fs14 fwb">¥</div>
                <div class="fs16 fwb" v-if="item.min_max_price[0].min_price">
                  {{ item.min_max_price[0].min_price + "-" + item.min_max_price[0].max_price }}
                </div>
                <div class="fs14" v-if="item.unit">{{ "元 / " + item.unit }}</div>
              </div>
              <div class="flex-box">
                <div class="flex-grow-1 fs12 zcol96">
                  <div
                    class="mb5 m-ellipsis"
                    v-for="(params, paramsIndex) in item.params_text"
                    :key="paramsIndex"
                    v-show="paramsIndex < 3"
                  >
                    {{ params.title }}：{{ params.content }}
                  </div>
                  <!-- <div class="fs18 zcol96 m-ellipsis">有 效 期：2024.6.17</div> -->
                </div>
                <i class="icon_cart"></i>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="currentData.current_page < currentData.last_page"
          class="flex-box flex-center flex-col-start more"
          @click="getMoreGoods"
        >
          <div class="fs16">点击查看更多</div>
          <img src="@/assets/static/icon/z_icon_down3.png" class="icon_down" />
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { useHead } from "@unhead/vue";
import { onMounted } from "vue";
import "viewerjs/dist/viewer.css";
import { component as Viewer } from "v-viewer";
import { api as viewerApi } from "v-viewer";
export default {
  name: "BrandShowDetail",
  components: { Viewer },
  data() {
    return {
      userInfo: null,
      id: 0,
      brand: { name: "" },
      goodsList: [],
      page: 1,
      currentData: { current_page: 1, last_page: 1 },
      isLogin: false,
      tabIndex: 0,
    };
  },
  created() {
    if (this.$cookies.get("token")) {
      this.isLogin = true;
      this.userInfo = this.$cookies.get("userinfo");
    }
    this.id = this.$route.query.id || 0;
    this.brandDetail();
    this.brandGoods();
  },
  methods: {
    brandDetail() {
      let that = this;
      let query = {
        id: this.id,
      };
      that.$api
        .GetBrandDetail(query)
        .then((res) => {
          if (res.code == 1) {
            this.brand = res.data;
            useHead({
              title: res.data.name,
              meta: [
                { name: "description", content: "This is my page description" },
                { property: "og:title", content: "My Page Title" },
                { property: "og:description", content: "This is my page description" },
                { property: "og:url", content: "https://example.com/my-page" },
                { property: "og:image", content: "https://example.com/my-image.jpg" },
              ],
              link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    brandGoods() {
      let that = this;
      let query = {
        brand_id: that.id,
        list_rows: 10,
        page: this.page,
      };
      that.$api
        .GetGoods(query)
        .then((res) => {
          if (res.code == 1) {
            that.goodsList = this.goodsList.concat(res.data.data);
            that.currentData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMoreGoods() {
      this.page = this.page + 1;
      this.brandGoods();
    },
    onDetail(id) {
      if (this.isLogin == false) {
        this.$router.push({ path: "/FindProductDetail", query: { id: id } });
      } else {
        const routeData = this.$router.resolve({
          name: "FindProductDetail", // 目标路由的名称
          query: { id },
        });
        window.open(routeData.href, "_blank");
      }
    },
    testTabClick(index) {
      this.tabIndex = index;
    },
    showImagesInViewer(urls,i) {
      // urls = [{src:'',},]
      urls instanceof Array && urls?.length && viewerApi({ images: urls,options:{
        initialViewIndex: i
      } });
    },
  },
};
</script>
<style lang="less" scoped>
.brand_show_detail {
  padding-bottom: 0.2rem;
  .wrap1 {
    padding: 14px 0;
  }
  .img_detail {
    display: block;
    width: 100%;
  }
}
.product_box1 {
  position: relative;
  margin: 14px auto 0;
  padding: 14px 14px 1px;
  border-radius: 18px;
  background-color: #fff;

  .nav_more {
    color: #6b6b6b;
  }
  .nav_more::after {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    background-image: url(@/assets/static/icon/jj_icon_arrow1.png);
    background-size: 12px;
    background-repeat: no-repeat;
  }

  .title {
    font-size: 16px;
    color: #272727;
  }

  .more {
    padding: 6px 0 0;
    line-height: 28px;
    cursor: pointer;
    div {
      color: #6b6b6b;
    }
    .icon_down {
      margin-left: 10px;
      display: block;
      width: 18px;
      height: 18px;
    }
  }
}

.product_list1 {
  margin: 14px 0 0;
  .product_item {
    margin: 0 14px 14px 0;
    width: calc((100% - 42px) / 4);
    height: 470px;
    background: #ffffff;
    border-radius: 18px;
    border: 1px solid #ececec;
    .img_wrap {
      position: relative;
      width: 100%;
      height: 310px;
      border-bottom: 2px solid #ececec;
      .img1 {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        width: 72%;
      }
    }
    .info_wrap {
      padding: 14px;
      .name {
        color: #272727;
      }

      .icon_cart {
        display: block;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background-image: url(@/assets/static/icon/z_icon_cart1.png);
        background-size: 56px;
        background-repeat: no-repeat;
      }
    }
  }
  .product_item:nth-of-type(4n) {
    margin: 0 0 20px;
  }
}

.top_info_box {
  padding: 14px;
  border-radius: 12px;
  background: #ffffff;
  h1 {
    margin: 0 0 30px;
    color: #272727;
    font-size: 30px;
    font-weight: 700;
  }
  .info {
    color: #969696;
    font-size: 14px;
    line-height: 2;
  }
  .key {
    width: 4em;
  }
  .img_box {
    position: relative;
    width: 350px;
    height: 180px;
    border-radius: 12px;
    border: 1px solid #ececec;
    background: #ffffff;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      max-width: 95%;
      max-height: 95%;
    }
  }
}

.brand_tab_row {
  margin-top: 14px;
  height: 70px;
  background: #f7faff;
  .tab {
    width: 250px;
    height: 70px;
    font-size: 16px;
    color: #040404;
    border-right: 0.5px solid #ececec;
    cursor: pointer;
    i {
      margin-right: 8px;
      display: block;
      background-repeat: no-repeat;
    }
    .icon1 {
      width: 20px;
      height: 20px;
      background-image: url(@/assets/static/icon/z_icon_brand1.png);
      background-size: 20px;
    }
    .icon2 {
      width: 22px;
      height: 20px;
      background-image: url(@/assets/static/icon/z_icon_brand2.png);
      background-size: 22px 20px;
    }
    .icon3 {
      width: 22px;
      height: 22px;
      background-image: url(@/assets/static/icon/z_icon_brand3.png);
      background-size: 22px;
    }
    .icon4 {
      width: 18px;
      height: 22px;
      background-image: url(@/assets/static/icon/z_icon_brand4.png);
      background-size: 18px 22px;
    }
  }
  .tab.active {
    color: #fff;
    background: #3d7efe;
    .icon1 {
      background-image: url(@/assets/static/icon/z_icon_brand1on.png);
    }
    .icon2 {
      background-image: url(@/assets/static/icon/z_icon_brand2on.png);
    }
    .icon3 {
      background-image: url(@/assets/static/icon/z_icon_brand3on.png);
    }
    .icon4 {
      background-image: url(@/assets/static/icon/z_icon_brand4on.png);
    }
  }
}

.detail_box {
  background: #ffffff;
  .block1 {
    padding: 14px;
    /deep/img {
      margin: 0 auto;
      display: block;
    }
    .video_box {
      position: relative;
      padding: 14px;
      margin: 14px auto 0;
      width: 1045px;
      height: 600px;
      background: #eff6ff;
      border-radius: 24px;
      .video {
        display: block;
        width: 100%;
        height: 572px;
        background: #3d7efe;
        border-radius: 12px;
        object-fit: fill;
      }
      .icon_play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        cursor: pointer;
      }
    }
  }

  .block2 {
    padding: 14px;
    ul {
      li {
        position: relative;
        margin: 0 14px 14px 0;
        // width: 212px;
        width: calc((100% - 70px) / 6);
        height: 160px;
        border-radius: 12px;
        cursor: pointer;
        .img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: block;
          max-width: 80%;
          height: 90%;
        }
        .preview {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: none;
          background: rgba(86, 86, 86, 0.4);
          border-radius: 12px;
          i {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            display: block;
            width: 78px;
            height: 32px;
            background-size: 78px 32px;
            background-repeat: no-repeat;
            background-image: url(@/assets/static/icon/z_icon_preview.png);
          }
        }
      }
      li:hover {
        .img {
          transform: translate(-50%, -50%) scale(1.05);
        }
        .preview {
          display: block;
        }
      }
      li:nth-of-type(6n) {
        margin: 0 0 14px;
      }
    }
  }

  .block3 {
    padding: 14px;
  }
}

@media screen and (max-width: 1440px) {
	.block2 {
    ul{
      li{
        height: 140px!important;
      }
    }
  }
	}
</style>
